export default "__VITE_ASSET__BRwwv6BU__"